import { Prisma } from "@prisma/client";
import { fileSelectValues } from "../file.types";

export const eventDocumentTypeValues =
  Prisma.validator<Prisma.EventStructureDocumentDefaultArgs>()({
    select: {
      id: true,
      order: true,
      eventStructureId: true,
      createdAt: true,
      updatedAt: true,
      structureDocument: {
        select: {
          id: true,
          name: true,
          link: true,
          file: {
            select: fileSelectValues,
          },
          thumbnail: {
            select: fileSelectValues,
          },
        },
      },
    },
  });

export type EventDocumentType = Prisma.EventStructureDocumentGetPayload<
  typeof eventDocumentTypeValues
>;
